import { HttpLink } from 'apollo-angular/http';
import { getOperationAST } from 'graphql';
import { createWsClient } from './wsclient';
import { concat, ApolloLink } from '@apollo/client/core';
import repairHeaderWare from './transformers/repair-header-ware';
import authWare from './transformers/auth-ware';
import { ConfigService } from '../app/shared/services/config/config.service';

export function provideNetworkInterfaceWithSubscriptions(
  httpLink: HttpLink,
  configService: ConfigService
): ApolloLink {
  const networkInterface = httpLink.create({ uri: configService.config.apollo.apiUrl });
  const wsClient = createWsClient(configService);

  return ApolloLink.split(
    (operation) => {
      const operationAST = getOperationAST(
        operation.query,
        operation.operationName
      );
      return !!operationAST && operationAST.operation === 'subscription';
    },
    wsClient,
    concat(concat(repairHeaderWare, authWare), networkInterface)
  );
}
